/** Auto : création / envoi le jour prévu. L’échéance = paiement. */
import { CheckField } from "../../components/CheckField";
import { FxTime } from "../../components/FxTime";
import type { CompanyPayments } from "../../payments/types";

type PaymentsRhythmProps = {
  draft: CompanyPayments;
  setDraft: (next: CompanyPayments) => void;
};

export function PaymentsAuto({ draft, setDraft }: PaymentsRhythmProps) {
  return (
    <>
      <div className="fx-fmt-row fx-fmt-row--top">
        <span>Factures standard</span>
        <div className="fx-fmt-row__main">
          <CheckField
            label="Encaisser automatiquement à l’échéance"
            checked={draft.auto_bill_invoices}
            onChange={(next) => setDraft({ ...draft, auto_bill_invoices: next })}
          />
          <label className="fx-field flex flex-col gap-1 text-xs">
            Heure d’envoi à GoCardless
            <FxTime
              id="pay_gc_at"
              value={draft.gc_charge_at}
              onChange={(gc_charge_at) => setDraft({ ...draft, gc_charge_at })}
            />
          </label>
          <p className="fx-co-form__hint m-0">
            Facture validée due aujourd’hui (ou en retard) → même envoi que Prélever, si mandat SEPA.
            Heure Paris, minutes par quarts (:00 / :15 / :30 / :45). PayPal / Stripe : plus tard. Webhook → Payé ou Rejeté.
          </p>
        </div>
      </div>
      <div className="fx-fmt-row fx-fmt-row--top">
        <span>Factures récurrentes</span>
        <div className="fx-fmt-row__main">
          <CheckField
            label="Créer et envoyer le jour prévu"
            checked={draft.auto_bill_recurring === "send"}
            onChange={(next) => setDraft({ ...draft, auto_bill_recurring: next ? "send" : "off" })}
          />
          <label className="fx-field flex flex-col gap-1 text-xs">
            Heure de création / envoi
            <FxTime
              id="pay_bill_at"
              value={draft.auto_bill_at}
              onChange={(auto_bill_at) => setDraft({ ...draft, auto_bill_at })}
            />
          </label>
          <p className="fx-co-form__hint m-0">
            Le jour prévu, à cette heure, la facture est créée et envoyée. L’échéance (1 à 31 jours) reste
            la date de paiement, pas la date d’envoi.
          </p>
        </div>
      </div>
    </>
  );
}
